<div class="flex flex-col p-4">
  <div class="h-8 w-8">
    <app-left-arrow-icon
      class="cursor-pointer"
      (click)="location.back()"
    ></app-left-arrow-icon>
  </div>

  @if (error) {
    <div class="mt-4">
      <p class="text-error">{{ error }}</p>
    </div>
  } @else if (loadingProduct) {
    <div class="mt-4 flex justify-center">
      <div class="loading loading-spinner"></div>
    </div>
  } @else if (!product) {
    <div class="mt-4 flex justify-center">
      <p class="text-error">No product found</p>
    </div>
  } @else {
    <div>
      <div class="card">
        <div class="card-body flex-row justify-between">
          <div>
            <h4 class="card-title">{{ product.product.title }}</h4>
            <p class="my-2 text-sm">
              <span class="font-bold">Description:</span>&nbsp;{{
                product.product.description
              }}
            </p>
            <div class="flex flex-row gap-3 text-sm">
              <span>
                <span class="font-bold">Active:</span>&nbsp;{{
                  product.product.active
                }}</span
              >
              <span>|</span>
              <span>
                <span class="font-bold">Code:</span>&nbsp;{{
                  product.product.code
                }}</span
              >
              <span>|</span>
              <span>
                <span class="font-bold">Variance:</span>&nbsp;{{
                  product.product.variance_code
                }}</span
              >
              <span>|</span>
              <span>
                <span class="font-bold">Type:</span>&nbsp;{{
                  product.product.type
                }}</span
              >
              <span>|</span>
              <span>
                <span class="font-bold">Is Service:</span>&nbsp;{{
                  product.product.is_service
                }}</span
              >
              <span>|</span>
              <span>
                <span class="font-bold">Active Desktop Licenses:</span>&nbsp;{{
                  product.active_desktop_license_count ?? 0
                }}</span
              >
            </div>
          </div>
          <div class="flex flex-row space-x-8">
            <button
              class="btn btn-primary"
              [routerLink]="'/admin/add-product-variant/' + product.product.id"
            >
              <app-plus-icon class="h-6 w-6"></app-plus-icon>
              Add Variant
            </button>
            <button
              class="btn btn-secondary"
              [routerLink]="'/admin/edit-product/' + product.product.id"
            >
              <app-edit-icon class="h-6 w-6"></app-edit-icon>
              Edit
            </button>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto rounded-lg border border-base-content/20">
        <table class="table table-md">
          <thead class="text-sm font-medium">
            <tr>
              <th>Default?</th>
              <th>Duration<br />(Months)</th>
              <th>Delivery<br />Method</th>
              <th>Price<br />Lock<br />Level</th>
              <th>Price</th>
              <th>Renewal<br />Price</th>
              <th>Site<br />Price</th>
              <th>Site<br />Renewal<br />Price</th>
              <th>Active</th>
              <th>Active<br />Desktop<br />Licenses</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            @for (variant of displayVariants; track variant; let i = $index) {
              <tr
                [ngClass]="{
                  'bg-base-300': i === currentVariantIndex,
                  'bg-base-200': i % 2 === 0,
                }"
                class="cursor-pointer"
                [routerLink]="'/admin/edit-product-variant/' + variant.id"
              >
                <td>{{ variant.is_default }}</td>
                <td>{{ variant.duration_months }}</td>
                <td>{{ variant.delivery_method }}</td>
                <td>{{ variant.price_lock_level }}</td>
                <td>{{ variant.price | currency }}</td>
                <td>{{ variant.renewal_price | currency }}</td>
                <td>{{ variant.site_price | currency }}</td>
                <td>{{ variant.site_renewal_price | currency }}</td>
                <td>{{ variant.active }}</td>
                <td class="text-center">
                  {{ variant.active_desktop_license_count ?? 0 }}
                </td>
                <td class="text-nowrap">
                  {{ variant.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
